var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailIncoming = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66659 10.6344C7.66659 8.42773 9.45992 6.6344 11.6666 6.6344C12.3999 6.6344 13.0799 6.8344 13.6666 7.1744V1.96773C13.6666 1.22773 13.0666 0.634399 12.3333 0.634399H1.66659C0.926585 0.634399 0.333252 1.22773 0.333252 1.96773V9.96773C0.333252 10.7077 0.933252 11.3011 1.66659 11.3011H7.72659C7.69325 11.0811 7.66659 10.8611 7.66659 10.6344ZM1.66659 3.30107V1.96773L6.99992 5.30107L12.3333 1.96773V3.30107L6.99992 6.6344L1.66659 3.30107ZM10.9999 8.6344V9.96773H13.6666V11.3011H10.9999V12.6344L8.99992 10.6344L10.9999 8.6344Z",
    fill: "#1677FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailIncoming);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-incoming.ad74538c9a2cf3eaec02825fe8c3f1f8.svg";